import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const publicApi = {
  getTodayTips: (deviceToken) =>
    api.get(`/tips/today`, { params: { device_token: deviceToken } }).then((r) => r.data),
  unlockStatus: (deviceToken, raceDate) =>
    api
      .get(`/unlock/status`, { params: { device_token: deviceToken, race_date: raceDate } })
      .then((r) => r.data),
  results30: () => api.get(`/results/last30`).then((r) => r.data),
  createCheckout: (payload) => api.post(`/payments/checkout`, payload).then((r) => r.data),
  paymentStatus: (sessionId) => api.get(`/payments/status/${sessionId}`).then((r) => r.data),
  registerDevice: (payload) => api.post(`/device/register`, payload).then((r) => r.data),
  restoreDevice: (payload) => api.post(`/device/restore`, payload).then((r) => r.data),
  vapidPublic: () => api.get(`/push/vapid-public`).then((r) => r.data),
  pushSubscribe: (payload) => api.post(`/push/subscribe`, payload).then((r) => r.data),
  publicConfig: () => api.get(`/config/public`).then((r) => r.data),
};

export const adminApi = {
  login: (password) => api.post(`/admin/login`, { password }).then((r) => r.data),
  listTips: (token, raceDate) =>
    api
      .get(`/admin/tips`, {
        headers: { "X-Admin-Token": token },
        params: raceDate ? { race_date: raceDate } : {},
      })
      .then((r) => r.data),
  createTip: (token, payload) =>
    api.post(`/admin/tips`, payload, { headers: { "X-Admin-Token": token } }).then((r) => r.data),
  deleteTip: (token, id) =>
    api.delete(`/admin/tips/${id}`, { headers: { "X-Admin-Token": token } }).then((r) => r.data),
  editTip: (token, id, payload) =>
    api.patch(`/admin/tips/${id}`, payload, { headers: { "X-Admin-Token": token } }).then((r) => r.data),
  updateResult: (token, id, payload) =>
    api
      .patch(`/admin/tips/${id}/result`, payload, { headers: { "X-Admin-Token": token } })
      .then((r) => r.data),
  refundDay: (token, id) =>
    api
      .post(`/admin/tips/${id}/refund-day`, {}, { headers: { "X-Admin-Token": token } })
      .then((r) => r.data),
  stats: (token) =>
    api.get(`/admin/stats`, { headers: { "X-Admin-Token": token } }).then((r) => r.data),
  broadcast: (token, payload) =>
    api
      .post(`/admin/push/broadcast`, payload, { headers: { "X-Admin-Token": token } })
      .then((r) => r.data),
  getConfig: (token) =>
    api.get(`/admin/config`, { headers: { "X-Admin-Token": token } }).then((r) => r.data),
  setFreeMode: (token, enabled) =>
    api
      .post(`/admin/config/free-mode`, { enabled }, { headers: { "X-Admin-Token": token } })
      .then((r) => r.data),
  getExtraInfo: () => api.get(`/config/extra-info`).then((r) => r.data),
  setExtraInfo: (token, text) =>
    api
      .post(`/admin/config/extra-info`, { text }, { headers: { "X-Admin-Token": token } })
      .then((r) => r.data),
};
